export default __webpack_public_path__ + "static/media/blm.cf539fd4.png";